import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NgxsModule } from "@ngxs/store";
import { FormStateModule } from "app/company/form-state/form-state.module";
import { SharedModule } from "app/shared/shared.module";
import { MemberStatusStoreModule } from "~app/addresses/store/member-status/member-status.module";
import { AnnualDeclarationState } from "~app/company/form/annual-declaration-form/shared/state/annual-declaration.state";
import { SubscriptionFarpOdqModule } from "~app/farp-odq/subscription-farpodq.module";
import { MaterialModule } from "../shared/material.module";
import { HomeFarpOdqComponent } from "./home-farp-odq/home-farp-odq.component";
import { HomeLegalEntityComponent } from "./home-legal-entity/home-legal-entity.component";
import { HomeComponent } from "./home.component";
import { HomeRoutes } from "./home.routing";

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule.forChild(HomeRoutes),
    TranslateModule,
    SharedModule,
    FormStateModule,
    NgxsModule.forFeature([AnnualDeclarationState]),
    MemberStatusStoreModule,
    SubscriptionFarpOdqModule,
    MatButtonModule,
    MatCardModule,
  ],
  declarations: [HomeComponent, HomeLegalEntityComponent, HomeFarpOdqComponent],
})
export class HomeModule {}
